/* eslint-disable no-shadow */

const ufeApi = require('services/api/ufeApi');
const updateProfile = require('services/api/profile/updateProfile');


const {
    EmailSubscriptionTypes,
    SubscriptionStatus
} = require('../constants');


function getNotificationsAndRemindersPreferences(userProfileId) {
    const url = `/api/users/profiles/${userProfileId}?` +
                'propertiesToInclude=emailSubscriptionInfo';
    return ufeApi.makeRequest(url, { method: 'GET' }).
        then(data => {
            let promise;

            if (data.errorCode) {
                promise = Promise.reject(data);

            } else {
                const subscriptions = data.emailSubscriptionInfo || [];

                const triggeredSubs = subscriptions.filter(
                    data => data.subscriptionType ===
                                EmailSubscriptionTypes.TRIGGERED)[0];

                const subscribed = triggeredSubs &&
                        triggeredSubs.subscriptionStatus ===
                                SubscriptionStatus.SUBSCRIBED || false;

                const prefs = { subscribed };

                promise = Promise.resolve(prefs);
            }

            return promise;
        });
}

function setNotificationsAndRemindersPreferences(prefs) {
    return updateProfile({
        fragmentForUpdate: 'EMAIL_SUBSCRIPTION',
        emailSubscriptionInfo: {
            subScribeToEmails: prefs.subscribed,
            subscriptionType: EmailSubscriptionTypes.TRIGGERED
        }
    });
}


module.exports = {
    getNotificationsAndRemindersPreferences,
    setNotificationsAndRemindersPreferences
};
